import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utilities';

const initialState = {
    data: {},
    loading: false,
    error: null,
    posted: false,
    deleting: false,
    deleted: false,
    uploaded: false,
    progress: 0.0
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GALLERY_ADD_INIT:
            return updateObject(state, { loading: false, posted: false, error: null });

        case actionTypes.GALLERY_ADD_START:
            return updateObject(state, { loading: true });

        case actionTypes.GALLERY_ADD_SUCCESS:
            const newMenu = updateObject(action.data, { id: action.id });
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
                data: state.data.concat(newMenu)
            });

        case actionTypes.GALLERY_ADD_FAIL:
            return updateObject(state, { loading: false, posted: false, error: action.error });


        case actionTypes.GALLERY_FETCH_START:
            return updateObject(state, { loading: true });

        case actionTypes.GALLERY_FETCH_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });

        case actionTypes.GALLERY_FETCH_FAIL:
            return updateObject(state, { loading: false,  error: action.error });


        case actionTypes.GALLERY_DELETE_START:
            return updateObject(state, { deleting: true });

        case actionTypes.GALLERY_DELETE_SUCCESS:
           
            return updateObject(state, {
                deleting: false,
                deleted: true,
                error: null,
            });

        case actionTypes.GALLERY_DELETE_FAIL:
            return updateObject(state, { deleting: false, deleted: false, error: action.error });

        // Upload
        case actionTypes.GALLERY_UPLOADFILE_START:
            return updateObject(state, { uploaded: false });

        case actionTypes.GALLERY_UPLOADFILE_PROGRESS:
            return updateObject(state, { progress: action.progress });

        case actionTypes.GALLERY_UPLOADFILE_SUCCESS:
            return updateObject(state, { uploaded: true, progress: 0.0 });

        case actionTypes.GALLERY_UPLOADFILE_FAIL:
            return updateObject(state, { uploaded: false, error: action.error });


        default:
            return state;
    }
};


export default reducer;
